import { FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ControlProperty } from '../../../../../../common';
import { AllocationViewLeadUliModel } from '../allocation-view-lead-uli';
import { AllocationViewUliCarrierModel } from './carrier/allocation-carrier.model';
import { AllocationViewUliDriverInformationModel } from './driver-info/allocation-driver-information.model';
import {
  AllocationViewUliDriverSignatureForm,
  AllocationViewUliDriverSignatureModel,
} from './driver-signature/allocation-driver-signature.model';
import {
  AllocationViewUliTruckInformationFormOutputModel,
  AllocationViewUliTruckInformationModel,
} from './truck-info/allocation-truck-information.model';
import { AllocationViewUliCommentsForm, AllocationViewUliCommentsModel } from './uli-comments/uli-comments.model';
import { AllocationViewUliInfoItemModel } from './uli-info/uli-info-item.model';

export class UliDetailsModel {
  hubId: number;
  ulis: AllocationViewUliInfoItemModel[];
  truckInformation: AllocationViewUliTruckInformationModel;
  driverInformation: AllocationViewUliDriverInformationModel;
  comments: AllocationViewUliCommentsModel;
  carrier: AllocationViewUliCarrierModel;
  propertyOfAnother: boolean;
  driverSignature: string;

  constructor(params?: UliDetailsModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewRegisterUliModel {
  hubId: number;
  ulis: AllocationViewUliInfoItemModel[];
  truckInformation: AllocationViewUliTruckInformationModel;
  driverInformation: AllocationViewUliDriverInformationModel;
  comments: AllocationViewUliCommentsModel;
  carrier: AllocationViewUliCarrierModel;
  propertyOfAnother: boolean;
  driverSignature: string;

  constructor(params?: AllocationViewRegisterUliFormModel) {
    if (params) {
      const { propertyOfAnother, carrier, ...truckInformation } = params.truckInformation;

      this.hubId = params.hubId;
      this.ulis = params.ulis;
      this.truckInformation = truckInformation;
      this.driverInformation = params.driverInformation;
      this.comments = params.comments;
      this.carrier = carrier;
      this.propertyOfAnother = propertyOfAnother;
      this.driverInformation.signature = params.signatures.updateDataSignature;
      this.driverInformation.storeFrequentDriver = params.signatures.storeFrequentDriver;
    }
  }
}

export class AllocationViewRegisterUliFormModel {
  hubId: number;
  truckInformation: AllocationViewUliTruckInformationFormOutputModel;
  ulis: AllocationViewUliInfoItemModel[] = [];
  driverInformation: AllocationViewUliDriverInformationModel;
  comments: AllocationViewUliCommentsModel;
  signatures: AllocationViewUliDriverSignatureModel;

  constructor(params?: UliDetailsModel, _leadUlis?: AllocationViewLeadUliModel[]) {
    if (params) {
      const truckInformation = {
        ...params.truckInformation,
        carrier: params.carrier,
        propertyOfAnother: params.propertyOfAnother,
        truckToCouple: null,
        coupling: false,
        decoupling: false,
      };

      this.hubId = params.hubId;
      this.truckInformation = truckInformation;
      this.ulis = params.ulis;
      this.driverInformation = new AllocationViewUliDriverInformationModel(params.driverInformation);
      this.comments = params.comments;
      this.signatures = new AllocationViewUliDriverSignatureModel();
    }
  }
}

export class AllocationViewRegisterUliForm {
  constructor(
    model: AllocationViewRegisterUliFormModel,
    fb: UntypedFormBuilder,
    public hubId: ControlProperty<number> = model.hubId,
    public truckInformation: ControlProperty<AllocationViewUliTruckInformationFormOutputModel> = [
      model.truckInformation,
      [Validators.required],
    ],
    public ulis: FormControl = fb.control(model.ulis),
    public driverInformation: ControlProperty<AllocationViewUliDriverInformationModel> = [
      model.driverInformation,
      [Validators.required],
    ],
    public comments: FormGroup = null,
    public signatures: FormGroup = fb.group(
      new AllocationViewUliDriverSignatureForm(new AllocationViewUliDriverSignatureModel()),
    ),
  ) {
    this.comments = fb.group(new AllocationViewUliCommentsForm(new AllocationViewUliCommentsModel(model.comments), fb));
  }
}
